import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import ViewIntro from '../../components/ViewIntro'
import draggable from 'vuedraggable'

export default {
  name: 'Testimonials',
  data,
  methods,
  mounted,
  components: {
    ViewIntro,
    draggable,
  },
}
